import React from "react";
import {NavLink, useNavigate, useParams} from "react-router-dom";
import * as Utils from "../../inc/Utils";
import {Config} from "../../Config";
import toast, {Toaster} from "react-hot-toast";
import moment from "moment-timezone";
import MemberSidebar from "../../inc/MemberSidebar";
import {confirmAlert} from "react-confirm-alert";
import "react-datepicker/dist/react-datepicker.css";
import MD5 from "crypto-js/md5";

export default function BusinessFormCertificate(prop) {
    let navigate = useNavigate();
    let {encode} = useParams();
    let decode = Utils.decodeItem(encode);
    let formId = decode.id;

    let member = prop.member;
    let [data, setData] = React.useState(null);
    let [detail, setDetail] = React.useState(null);

    React.useEffect(() => {
        document.title = 'แบบฟอร์มคำร้องขอการรับรองคุณภาพ - NCSA';

        (async function() {
            try {
                const resData = await getView();
                setData(resData);
                const resDetail = await getCertificate();
                setDetail(resDetail);
            } catch (e) {
                //
            }
        })();

    }, []);

    async function getView() {
        const response = await fetch(Config.apiUrl +'/cyberForm/viewByMember', {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                'x-access-token': member.accessToken
            },
            body: JSON.stringify({
                id: formId
            })
        });

        if(response.ok) {
            return response.json();
        }
        else {
            return response.json().then(err => Promise.reject(err));
        }
    }

    async function getCertificate() {
        const response = await fetch(Config.apiUrl +'/cyberFormCertificate/viewByMember', {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                'x-access-token': member.accessToken
            },
            body: JSON.stringify({
                formId: formId
            })
        });

        if(response.ok) {
            return response.json();
        }
        else {
            return response.json().then(err => Promise.reject(err));
        }
    }

    return (
        <>
            <div className="section">
                <div className="container has-sidebar">
                    <div className="sidebar">
                        <MemberSidebar active="businessForm" lang={prop.lang} />
                    </div>
                    <div className="content">
                        <div className="card-infos has-shadow-black" data-aos="fade-in">
                            <div className="d-flex justify-content-between gap-3">
                                <h3 className="title-line-left mt-0 mb-4">{prop.lang === 'en' ? 'Business Quality Form':'แบบฟอร์มคำร้องขอการรับรองคุณภาพ'}</h3>
                                <NavLink to={'/businessForm'} className="btn btn-xs btn-gray">&larr; กลับไป</NavLink>
                            </div>

                            <div className="row g-3">
                                <div className="col-12">
                                    <div className="form-group">
                                        <h6>เลขที่คำขอ</h6>
                                        <div>{data?.code ?? '-'}</div>
                                    </div>
                                </div>
                                <div className="col-12">
                                    <div className="form-group">
                                        <h6>เลขรับรอง</h6>
                                        <div>{detail?.code ?? '-'}</div>
                                    </div>
                                </div>
                                <div className="col-12">
                                    <div className="form-group">
                                        <h6>รายละเอียด</h6>
                                        <div>{detail?.detail ?? '-'}</div>
                                    </div>
                                </div>
                                <div className="col-12">
                                    <div className="form-group">
                                        <h6>วันที่หมดอายุ</h6>
                                        <div>{detail?.expireDate ? Utils.dateTimeDMY(detail?.expireDate) : '-'}</div>
                                    </div>
                                </div>
                                <div className="col-12">
                                    <div className="form-group">
                                        {
                                            detail?.fileCertificate ? <NavLink to={Config.fileUpload + 'cyber_form_certificate/' + detail.fileCertificate} target="_blank" className="btn btn-xs btn-green">&darr; เอกสารใบรับรองตัวจริง</NavLink> : 'ยังไม่ได้ระบุ'
                                        }
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Toaster position="top-right" />
        </>
    );
} 